import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createWebhook } from '../../../../common/api/clients/webhooks.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useWebhookCreate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createWebhook,
        onSuccess: () => {
            return queryClient.invalidateQueries({ queryKey: queries.webhooks.list._def });
        },
    });
};
